import React, { useEffect, useState } from "react";
import profileBanner from "../../Assets/images/profile-bnr.webp";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import RequestQuoteValidation from "../../Validation/RequestQuoteValidation";
import { useForm } from "react-hook-form"
import { yupResolver } from '@hookform/resolvers/yup';
import { Link, useNavigate } from "react-router-dom";
import { getFromStorage, imageExtentionSupport, ImageVideoExtentionSupport, saveToStorage, videoExtentionSupport } from "../../utils/Helper";
import { ApiTypes, StorageConstant } from "../../constants/Constants";
import FrontLoader from "../layout/FrontLoader";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { LanguageConstants } from "../../constants/LanguageConstants";
import { socket } from "../../utils/Socket";
import Select from "react-select";
interface QuoteInput {
  brand_name: string;
  part_number: string;
  quantity: number;
  description?: string;    // Optional
  serial_number?: string;  // Optional
  model_number?: string;   // Optional
  file_path?: string;   // Optional
  video_path?: string;   // Optional
  file_path2?: string;
  is_other_brand: string;
  other_brand_name: string;
  media_type: string;
  file_limit: string
}

interface FormInputs {
  quotes: QuoteInput[];
}

function RequestQuote() {
  const brandList = useMakeRequest()
  const quoteAdd = useMakeRequest()
  const quoteImageVideo = useMakeRequest()
  const quoteDelete = useMakeRequest()
  const ProductAdd = useMakeRequest()
  const Reset = useMakeRequest()
  const [indexId, setIndexId] = useState('0')   // this index for image and video add
  const [deleteIndexId, setDeleteIndexId] = useState('0')  // this index for image and video delete
  const [deleteType, setDeleteType] = useState('')  // this  for  delete  like video and image type
  const [mediaType, setMediaType] = useState('one')
  const [fileposition, setFileposition] = useState('')
  const [deleteImagePosition, setDeleteImageposition] = useState('')
  const navigate = useNavigate()
  const { state } = useLocation();
  const [brandissue, setBrandIssue] = useState(false)
  const addressDetails = getFromStorage({ key: "addres_deatil" });
  const [videoimit, setVideoLimit] = useState<any>('0')
  const [imageimit, setImageLimit] = useState<any>('0')
  const [brandInputValues, setBrandInputValues] = useState<{ [key: number]: string }>({})


  const [qoute, setQoute]: any = useState([{ id: 1, brand_name: '', part_number: '', quantity: '', description: '', serial_number: '', model_number: '', other_brand_name: '', file_path: '', file_path2: '', video_path: '' }])
  useEffect(() => {
    brandList.makeRequest({ url: ApiConstants?.BrandList, toastStatus: false })
  }, [])
  const handleAddDiv = () => {
    setImageLimit('0')
    setVideoLimit('0')
    setFileposition('')
    const newqouteId = String(qoute.length + 1);
    setQoute([...qoute, { id: newqouteId }]);
  };
  const handleRemoveDiv = (id: any) => {
    const qt = qoute.filter((div: any) => div.id !== id)
    setQoute(qt);
    setValue('quotes', qt)
  };

  const { register, handleSubmit, formState: { errors }, setValue, watch } = useForm<FormInputs>({
    defaultValues: {
      quotes: [{ media_type: "one" }]
    },
    resolver: yupResolver(RequestQuoteValidation),
  });

  const onSubmit = (data: any) => {
    if (brandissue) {
      toast.error(LanguageConstants?.BRAND_NAME_ALREDY)
    } else {
      const quotes: any = []
      data?.quotes?.map((res: any) => (
        quotes.push({
          brand_id: res?.brand_name,
          quantity: res?.quantity,
          part_number: res?.part_number,
          description: res?.description,
          serial_number: res?.serial_number,
          model_number: res?.model_number,
          file_path: res?.file_path,
          video_path: res?.video_path,
          file_path2: res?.file_path2,
          thumb_file_path: null,
          other_brand_name: res?.other_brand_name ? res?.other_brand_name : null,
          is_other_brand: res?.brand_name == '0' ? '1' : '0'
        })
      ))
      const payload = {
        // quotes: quotes
        quotes: quotes,
        // address_id: addressDetails?.address_id,
        // shipping_id: addressDetails?.shipping_id

      }
      if (state?.data) {
        const payload = {
          quotes: quotes,
          quotation_id: state?.data
        }
        saveToStorage({key:'another_product' , value:payload})
        navigate(`/view-quotation/${state?.data}`)
        // ProductAdd.makeRequest({ payload, url: ApiConstants?.QuotesProductAdd, toastStatus: true })
      } else {
        saveToStorage({ key: "quote_deatil", value: payload })
        navigate('/select-address')
        // quoteAdd.makeRequest({ payload, url: ApiConstants?.QuotesAdd, toastStatus: true })
      }
    }
  };
  useEffect(() => {
    if (quoteAdd?.status || ProductAdd.status) {
      navigate('/my-quotation')
      const payload = {
        sender_type: "1",
        receiver_id: '1'
      }
      socket.emit('admin_count', payload, async (Response: any) => { })
    }
  }, [quoteAdd.status, ProductAdd.status])

  const handleImage = (e: any, index: any, mediaSize: any) => {
    setIndexId(index)
    const file = e?.target?.files[0];
    const fileSizeInMB = file.size / (1024 * 1024)
    const getextention = e?.target?.files[0]?.name.split('.').pop()
    if (imageExtentionSupport?.includes(getextention)) {
      e.preventDefault();
      if (fileSizeInMB > 25) {
        toast.error("File size exceeds the maximum limit of 25 MB.");
        return;
      }
      let files;
      if (e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if (e.target) {
        files = e.target.files;
      }
      let payload = {}
      if (mediaSize == "one") {
        setFileposition('one')
        payload = {
          quote_image1: files[0]
        }
      } else {
        setFileposition('two')
        payload = {
          quote_image2: files[0]
        }
      }
      quoteImageVideo.makeRequest({ payload, type: ApiTypes?.POSTAPIFORMDATA, url: ApiConstants?.QuotesImage, toastStatus: false })
    } else {
      e.preventDefault();
      toast.error("Please upload valid image");
      return;
    }
  }

  const handleImageAndVideo = (e: any, index: any) => {
    setIndexId(index)
    var isImage = false
    var isVideo = false
    const files = e?.target?.files;
    const file = e?.target?.files[0];
    const fileSizeInMB = file.size / (1024 * 1024)
    const getextention = e?.target?.files[0]?.name.split('.').pop()
    if (watch(`quotes.${index}.video_path`) && videoExtentionSupport?.includes(getextention)) {
      toast.error(LanguageConstants?.MAX_VIDEO_LIMIT_ERROR);
      return;
    }
    if ((watch(`quotes.${index}.file_path`) && watch(`quotes.${index}.file_path2`)) && watch(`quotes.${index}.video_path`)) {
      toast.error(LanguageConstants?.IMAAGE_VIDEO);
      return;
    }
    if (fileposition == 'two') {
      toast.error(LanguageConstants?.IMAAGE_VIDEO);
      return;
    }
    if (videoExtentionSupport?.includes(getextention)) {
      isVideo = true
    }
    if (imageExtentionSupport?.includes(getextention)) {
      isImage = true
    }
    if (ImageVideoExtentionSupport?.includes(getextention)) {
      e.preventDefault();
      if (fileSizeInMB > 25) {
        toast.error("File size exceeds the maximum limit of 25 MB.");
        return;
      }
      let files;
      if (e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if (e.target) {
        files = e.target.files;
      }
      let payload = {}
      if (isVideo) {
        setVideoLimit('1')
        if(fileposition == 'one'){
           setFileposition('two')
        }else{
          setFileposition('one')
        }
        payload = {
          quote_video: files[0]
        }
      }
      if (isImage) {
        if (imageimit == 0) {
          setImageLimit('1')
          setFileposition('one')
          payload = {
            quote_image1: files[0]
          }
        } else {
          setFileposition('two')
          payload = {
            quote_image2: files[0]
          }
        }
      }
      quoteImageVideo.makeRequest({ payload, type: ApiTypes?.POSTAPIFORMDATA, url: ApiConstants?.QuotesImage, toastStatus: false })
    } else {
      e.preventDefault();
      toast.error(LanguageConstants?.VALIDIMAGE);
      return;
    }
  }

  // const handleImageAndVideo = (e: any, index: any) => {

  //   setIndexId(index)
  //   var isImage = false
  //   var isVideo = false
  //   const files = e?.target?.files;
  //   const imageArray = []
  //   const videoArray =[]
  //   setValue(`quotes.${index}.file_limit`, files?.length);
  //   if(files?.length >=3){
  //     toast.error(LanguageConstants?.IMAAGE_VIDEO);
  //   }
  //   for (let i = 0; i < files.length; i++) {
  //     const file = files[i];
  //     const fileSizeInMB = file.size / (1024 * 1024)
  //     if (fileSizeInMB > 25) {
  //       toast.error(LanguageConstants?.IMAGE_VIDEO_SIZE_ERROR);
  //       return;
  //     }
  //     const getextention = files[i]?.name.split('.').pop()
  //     if(videoExtentionSupport?.includes(getextention)){
  //       videoArray.push(file)
  //     }
  //     if(imageExtentionSupport?.includes(getextention)){
  //       imageArray.push(file)
  //     }
  //   }
  //   if(videoArray?.length > 1){
  //   setImageLimit('0')
  //     toast.error(LanguageConstants?.MAX_VIDEO_LIMIT_ERROR);
  //     return
  //   }
  //   if(imageArray?.length > 0){
  //   setImageLimit('0')
  //     if(imageArray[0]){
  //       setFileposition('one')
  //      const  payload = {
  //         quote_image1: imageArray[0]
  //       }
  //   quoteImageVideo.makeRequest({ payload, type: ApiTypes?.POSTAPIFORMDATA, url: ApiConstants?.QuotesImage, toastStatus: false })
  //     }
  //     if(imageArray[1]){
  //         setFileposition('two')
  //        const  payload = {
  //         quote_image2: imageArray[1]
  //         }
  //     quoteImageVideo.makeRequest({ payload, type: ApiTypes?.POSTAPIFORMDATA, url: ApiConstants?.QuotesImage, toastStatus: false })
  //    } 
  //   }
  //   if(videoArray?.length > 0){
  //    const payload = {
  //       quote_video: files[0]
  //     }
  //   setImageLimit('0')
  //   quoteImageVideo.makeRequest({ payload, type: ApiTypes?.POSTAPIFORMDATA, url: ApiConstants?.QuotesImage, toastStatus: false })
  //   }

  //   return 
  //   const file = e?.target?.files[0];
  //   const fileSizeInMB = file.size / (1024 * 1024)
  //   const getextention = e?.target?.files[0]?.name.split('.').pop()
  //   if(videoimit > 0 && videoExtentionSupport?.includes(getextention)){
  //     toast.error(LanguageConstants?.MAX_VIDEO_LIMIT_ERROR);
  //     return;
  //   }
  //   if(videoExtentionSupport?.includes(getextention)){
  //     isVideo = true
  //   }
  //   if(imageExtentionSupport?.includes(getextention)){
  //     isImage = true
  //   }

  // }

  const handleVideo = (e: any, index: any) => {
    const file = e?.target?.files[0];
    const fileSizeInMB = file.size / (1024 * 1024)
    setIndexId(index)
    const getextention = e?.target?.files[0]?.name.split('.').pop()
    e.preventDefault();
    if (videoExtentionSupport?.includes(getextention)) {
      if (fileSizeInMB > 25) {
        toast.error("File size exceeds the maximum limit of 25 MB.");
        return;
      }
      let files;
      if (e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if (e.target) {
        files = e.target.files;
      }
      const payload = {
        quote_video: files[0]
      }
      quoteImageVideo.makeRequest({ payload, type: ApiTypes?.POSTAPIFORMDATA, url: ApiConstants?.QuotesImage, toastStatus: false })
    } else {
      e.preventDefault();
      toast.error("Please upload valid video");
      return;
    }
  }

  useEffect(() => {
    if (quoteImageVideo?.status) {
      const ImageVideo = quoteImageVideo?.data?.file_path?.split('/videos')
      if (ImageVideo?.length >= 2) {
        const index = parseInt(indexId);
        setValue(`quotes.${index}.video_path`, quoteImageVideo?.data?.file_path);
        setQoute((prev: any) => (prev[index].video_path = quoteImageVideo?.data?.file_path, [...prev]));

      } else {

        if (fileposition == "one") {
          const index = parseInt(indexId);
          setValue(`quotes.${index}.file_path`, quoteImageVideo?.data?.file_path);
          setQoute((prev: any) => (prev[index].file_path = quoteImageVideo?.data?.file_path, [...prev]));
        } else {
          const index = parseInt(indexId);
          setValue(`quotes.${index}.file_path2`, quoteImageVideo?.data?.file_path);
          setQoute((prev: any) => (prev[index].file_path2 = quoteImageVideo?.data?.file_path, [...prev]));
        }

      }
    }
    Reset.reset()
  }, [quoteImageVideo?.status, indexId]);


  useEffect(() => {
    if (quoteDelete?.status) {
      if (deleteType == 'image') {
        if (deleteImagePosition == "one") {
          const index = parseInt(deleteIndexId);
          setValue(`quotes.${index}.file_path`, '');
        } else {
          const index = parseInt(deleteIndexId);
          setValue(`quotes.${index}.file_path2`, '');
        }
      } else {
        const index = parseInt(deleteIndexId);
        setValue(`quotes.${index}.video_path`, '');
      }
    }
  }, [deleteIndexId, quoteDelete?.status])


  const handelDeleteImageVideo = (e: any, index: any, type: any, position: any) => {
    setDeleteIndexId(index)
    setDeleteImageposition(position)
    setDeleteType(type)
    if (position == 'one') {
      setImageLimit('0')
      setFileposition('')
    }
    if (type == 'video') {
      setVideoLimit('0')
    }
    const payload = {
      file_path: e
    }

    quoteDelete.makeRequest({ payload, type: ApiTypes?.POST, url: ApiConstants?.QuotesImageRemove, toastStatus: true })
  }

  const handelImageVideo = (e: any, i: any) => {
    setMediaType(e)
    setValue(`quotes.${i}.media_type`, e)
    setValue(`quotes.${i}.file_path`, '');
    setValue(`quotes.${i}.file_path2`, '');
    setValue(`quotes.${i}.video_path`, '');
  }

  const handelOtherBrands = (e: any) => {
    const FindData = brandList?.data?.data?.find((res: any) => res?.brands_details?.name == e)
    if (FindData?.id) {
      toast.error('Brand name already exists.')
      return setBrandIssue(true)
    } else {
      return setBrandIssue(false)
    }
  }

  // Handle brand input change for searchable select
  const handleBrandInputChange = (inputValue: string, index: number) => {
    // Store the input value to check later on blur/menu close
    setBrandInputValues(prev => ({ ...prev, [index]: inputValue }))
  }

  // Handle brand selection from dropdown
  const handleBrandSelect = (selectedOption: any, index: number) => {
    if (selectedOption) {
      if (selectedOption.value === '0') {
        // User selected "Other Brand"
        const updatedQoutes = [...qoute];
        updatedQoutes[index].brand_name = '0';
        setQoute(updatedQoutes);
        setValue(`quotes.${index}.brand_name`, '0');
        setValue(`quotes.${index}.other_brand_name`, '');
        setBrandInputValues(prev => ({ ...prev, [index]: '' }))
      } else {
        // User selected a brand from list
        const updatedQoutes = [...qoute];
        updatedQoutes[index].brand_name = selectedOption.value;
        setQoute(updatedQoutes);
        setValue(`quotes.${index}.brand_name`, selectedOption.value);
        setBrandIssue(false);
        setBrandInputValues(prev => ({ ...prev, [index]: selectedOption.label }))
      }
    } else {
      // Clear selection
      const updatedQoutes = [...qoute];
      updatedQoutes[index].brand_name = '';
      setQoute(updatedQoutes);
      setValue(`quotes.${index}.brand_name`, '');
      setBrandInputValues(prev => ({ ...prev, [index]: '' }))
    }
  }

  // Check if typed value matches a brand and handle accordingly
  const checkAndHandleBrandInput = (index: number) => {
    const inputValue = brandInputValues[index] || '';
    const currentBrandValue = watch(`quotes.${index}.brand_name`);
    
    if (inputValue.trim() && currentBrandValue !== '0') {
      // Check if input matches any brand (case-insensitive)
      const matchedBrand = brandList?.data?.data?.find((res: any) => 
        res?.brands_details?.name?.toLowerCase() === inputValue.trim().toLowerCase()
      )
      
      if (matchedBrand) {
        // Match found, select the brand
        const updatedQoutes = [...qoute];
        updatedQoutes[index].brand_name = String(matchedBrand.id);
        setQoute(updatedQoutes);
        setValue(`quotes.${index}.brand_name`, String(matchedBrand.id));
        setBrandIssue(false);
        setBrandInputValues(prev => ({ ...prev, [index]: matchedBrand.brands_details.name }))
      } else if (!currentBrandValue) {
        // No match found and no brand selected, switch to other brand mode
        const updatedQoutes = [...qoute];
        updatedQoutes[index].brand_name = '0';
        updatedQoutes[index].other_brand_name = inputValue.trim();
        setQoute(updatedQoutes);
        setValue(`quotes.${index}.brand_name`, '0');
        setValue(`quotes.${index}.other_brand_name`, inputValue.trim());
        handelOtherBrands(inputValue.trim());
        setBrandInputValues(prev => ({ ...prev, [index]: '' }))
      }
    }
  }

  // Handle blur event - check if typed value should become "other brand" or match a brand
  const handleBrandBlur = (index: number) => {
    checkAndHandleBrandInput(index);
  }

  // Handle menu close - check if typed value should become "other brand" or match a brand
  const handleMenuClose = (index: number) => {
    // Small delay to allow selection to complete first
    setTimeout(() => {
      checkAndHandleBrandInput(index);
    }, 100);
  }

  const handelNavigateHome = ()=>{
        navigate('/', { state: { data: {modelShow:true} } })
  }

  
  return (
    <>
      {(quoteAdd.loading || ProductAdd.loading || quoteImageVideo.loading || quoteDelete.loading) ? <FrontLoader /> : null}
      <main>
        {/* top banner section start */}
        <section
          className="main-banner small-banner"
          style={{ background: `url(${profileBanner}) center/cover` }}
        >
          <div className="container">
            <h1 className="small-banner-heading">{state?.data ? LanguageConstants?.ADDMOREPRODUCT :LanguageConstants?.REQUESTQUOTES}</h1>
            {!state?.data ? 
             <nav className="com-breadcrumb" aria-label="breadcrumb">
                   <ol className="breadcrumb">
                     <li className="breadcrumb-item" style={{cursor:'pointer'}} ><a onClick={()=>handelNavigateHome()}>{LanguageConstants?.HOME}</a></li>
                     <li className="breadcrumb-item active" aria-current="page">{LanguageConstants?.REQUESTQUOTES}</li>
                   </ol>
                 </nav>
            :null}
          </div>
        </section>
        {/* top banner section end  */}


        <div className="footer-space">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="container">
              <div className="card-box mb-5">
                <div className="table-responsive com-table rqst-table">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="text-center ">{LanguageConstants?.Item}</th>
                        <th className="text-center ">{LanguageConstants?.BRANDNAME}<span className="red-text">*</span></th>
                        <th className="text-center large-table-col1">{LanguageConstants?.PARTNAME} <span className="red-text">*</span></th>
                        <th className="text-center"> {LanguageConstants?.QUANTITY} <span className="red-text">*</span></th>
                        <th className="text-center large-table-col">{LanguageConstants?.Description} <span className="red-text">*</span></th>
                        <th className="text-center large-table-col1">{LanguageConstants?.SERIALNUMBER}<span className="red-text"></span></th>
                        <th className="text-center large-table-col1">{LanguageConstants?.MODELNUMBER} <span className="red-text"></span></th>
                        {/* <th className="text-center large-table-col">{LanguageConstants?.UPLOADMEDIA}</th> */}
                        <th className="text-center large-table-col1">{LanguageConstants?.UPLOAD}</th>
                        {qoute?.length > 1 ?
                          <th className="text-center">{LanguageConstants?.ACTION}</th>
                          : null}
                      </tr>
                    </thead>
                    <tbody>
                      {qoute?.length > 0 && qoute.map((res: any, i: any) => (
                        <tr key={i}>
                          <td style={{ textAlign: 'center' }}>
                            {state?.quotes_length ?
                              <p style={{ marginBlock: 'auto' }}> {state?.quotes_length + i + 1}</p>
                              :
                              <p style={{ marginBlock: 'auto' }}> {i + 1}</p>
                            }
                          </td>
                          <td className="align-top">
                            {watch(`quotes.${i}.brand_name`) != "0" ?
                              <>
                                <div className="com-input-wrap">
                                  <Select
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        width: '180px',
                                        minHeight: '38px',
                                        height: '38px',
                                        borderColor: errors?.quotes?.[i]?.brand_name ? '#dc3545' : '#ced4da',
                                      }),
                                      valueContainer: (base) => ({
                                        ...base,
                                        height: '36px',
                                        padding: '0 8px',
                                      }),
                                      input: (base) => ({
                                        ...base,
                                        margin: '0px',
                                        padding: '0px',
                                      }),
                                      indicatorsContainer: (base) => ({
                                        ...base,
                                        height: '36px',
                                      }),
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                      menu: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    placeholder={LanguageConstants?.SELECTBRAND}
                                    isSearchable={true}
                                    isClearable={true}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    options={[
                                      ...(brandList?.data?.data?.map((res: any) => ({
                                        value: String(res?.id),
                                        label: res?.brands_details?.name
                                      })) || []),
                                      // { value: '0', label: LanguageConstants?.OTHER_BRAND }
                                    ]}
                                    value={
                                      watch(`quotes.${i}.brand_name`) 
                                        ? {
                                            value: watch(`quotes.${i}.brand_name`),
                                            label: watch(`quotes.${i}.brand_name`) === '0'
                                              ? LanguageConstants?.OTHER_BRAND
                                              : brandList?.data?.data?.find((res: any) => String(res?.id) === String(watch(`quotes.${i}.brand_name`)))?.brands_details?.name || ''
                                          }
                                        : null
                                    }
                                    onInputChange={(inputValue) => handleBrandInputChange(inputValue, i)}
                                    onChange={(selectedOption) => handleBrandSelect(selectedOption, i)}
                                    onBlur={() => handleBrandBlur(i)}
                                    onMenuClose={() => handleMenuClose(i)}
                                    filterOption={(option, inputValue) => {
                                      if (!inputValue) return true;
                                      const searchValue = inputValue.toLowerCase();
                                      return option.label.toLowerCase().includes(searchValue);
                                    }}
                                  />
                                  <input
                                    type="hidden"
                                    {...register(`quotes.${i}.brand_name`)}
                                  />
                                </div>
                                {errors?.quotes?.[i]?.brand_name && <p className="text-error-new mb-0 mt-1">{errors.quotes[i]?.brand_name?.message}</p>}
                              </>
                              :
                              <>
                                <div className="com-input-wrap">
                                  <input type="text" style={{ width: '165px' }} className="form-control" placeholder={`${LanguageConstants?.ENTER} ${LanguageConstants?.OTHER_BRAND_NAME}`}
                                    {...register(`quotes.${i}.other_brand_name`, {
                                      onChange: (event) => {
                                        handelOtherBrands(event.target.value)
                                        const updatedQoutes = [...qoute];
                                        updatedQoutes[i].other_brand_name = event.target.value; // Update the specific quote's other_brand_name
                                        setQoute(updatedQoutes); // Set the updated state
                                      }
                                    })}
                                  />
                                </div>
                                {errors?.quotes?.[i]?.other_brand_name && <p className="text-error-new mb-0 mt-1">{errors.quotes[i]?.other_brand_name?.message}</p>}
                              </>

                            }
                          </td>
                          <td className="align-top">
                            <div className="com-input-wrap">
                              <input type="text" className="form-control" placeholder={`${LanguageConstants?.ENTER} ${LanguageConstants?.PARTNAME}`}
                                {...register(`quotes.${i}.part_number`, {
                                  onChange: (event) => {
                                    const updatedQoutes = [...qoute];
                                    updatedQoutes[i].part_number = event.target.value; // Update the specific quote's part_number
                                    setQoute(updatedQoutes); // Set the updated state
                                  }
                                })}
                              />
                            </div>
                            {errors?.quotes?.[i]?.part_number && <p className="text-error-new mb-0 mt-1">{errors.quotes[i]?.part_number?.message}</p>}
                          </td>
                          <td className="align-top">
                            <div className="com-input-wrap">
                              <input type="text" className="form-control"
                                placeholder={`${LanguageConstants?.ENTER} ${LanguageConstants?.QUANTITY}`}
                                {...register(`quotes.${i}.quantity`, {
                                  onChange: (event) => {
                                    const updatedQoutes = [...qoute];
                                    updatedQoutes[i].quantity = event.target.value; // Update the specific quote's part_number
                                    setQoute(updatedQoutes); // Set the updated state
                                  }
                                })}
                              />
                            </div>
                            {errors?.quotes?.[i]?.quantity && <p className="text-error-new mb-0 mt-1">{errors.quotes[i]?.quantity?.message}</p>}
                          </td>
                          <td className="align-top">
                            <div className="com-input-wrap">
                              <input type="text" className="form-control" placeholder={`${LanguageConstants?.DESCIPTIONDETAILS}`}
                                {...register(`quotes.${i}.description`, {
                                  onChange: (event) => {
                                    const updatedQoutes = [...qoute];
                                    updatedQoutes[i].description = event.target.value; // Update the specific quote's part_number
                                    setQoute(updatedQoutes); // Set the updated state
                                  }
                                })}
                              />
                            </div>
                            {errors?.quotes?.[i]?.description && <p className="text-error-new mb-0 mt-1">{errors.quotes[i]?.description?.message}</p>}
                          </td>
                          <td className="align-top">
                            <div className="com-input-wrap">
                              <input type="text" className="form-control" placeholder={`${LanguageConstants?.ENTER} ${LanguageConstants?.SERIALNUMBER}`}
                                {...register(`quotes.${i}.serial_number`, {
                                  onChange: (event) => {
                                    const updatedQoutes = [...qoute];
                                    updatedQoutes[i].serial_number = event.target.value; // Update the specific quote's part_number
                                    setQoute(updatedQoutes); // Set the updated state
                                  }
                                })}
                              />
                            </div>
                            {errors?.quotes?.[i]?.serial_number && <p className="text-error-new mb-0 mt-1">{errors.quotes[i]?.serial_number?.message}</p>}
                          </td>
                          <td className="align-top">
                            <div className="com-input-wrap">
                              <input type="text" className="form-control" placeholder={`${LanguageConstants?.ENTER} ${LanguageConstants?.MODELNUMBER}`}
                                {...register(`quotes.${i}.model_number`, {
                                  onChange: (event) => {
                                    const updatedQoutes = [...qoute];
                                    updatedQoutes[i].model_number = event.target.value; // Update the specific quote's part_number
                                    setQoute(updatedQoutes); // Set the updated state
                                  }
                                })}
                              />
                            </div>
                            {errors?.quotes?.[i]?.model_number && <p className="text-error-new mb-0 mt-1">{errors.quotes[i]?.model_number?.message}</p>}
                          </td>
                          {/* <td className="align-top">
                            <div className="com-input-wrap">
                              <select
                                className="form-select"
                                aria-label="Default select example"
                                onChange={(e) => handelImageVideo(e?.target?.value, i)}
                              >
                                <option value='one'>{LanguageConstants?.ONEBYONE}</option>
                                <option value='two' >{LanguageConstants?.TWOBYTWO}</option>
                              </select>
                            </div>
                          </td> */}
                          <td className="align-top">
                            <div className="upload-btns">
                              <label className="upload-single">
                                <>
                                  <i className="icon-upload"></i><span></span>
                                  <input type="file" className="d-none" onChange={(e) => handleImageAndVideo(e, i)} />
                                </>
                              </label>


                              {watch(`quotes.${i}.file_path`) ?
                                <>

                                  <a>{LanguageConstants?.IMAGE1}</a>
                                  <a className="us-img-cancel" onClick={() => handelDeleteImageVideo(watch(`quotes.${i}.file_path`), i, 'image', "one")} ><i className="icon-delete"></i></a>

                                </>
                                : null}


                              {watch(`quotes.${i}.video_path`) ?
                                <>
                                  <a>Video</a>
                                  <a className="us-img-cancel" onClick={() => handelDeleteImageVideo(watch(`quotes.${i}.video_path`), i, 'video', 'one')} ><i className="icon-delete"></i></a>
                                </>
                                : null}

                              {watch(`quotes.${i}.file_path2`) ?
                                <>
                                  <a>{LanguageConstants?.IMAGE2}</a>
                                  <a className="us-img-cancel" onClick={() => handelDeleteImageVideo(watch(`quotes.${i}.file_path2`), i, 'image', 'two')} ><i className="icon-delete"></i></a>
                                </>
                                : null}
                            </div>
                          </td>
                          <td className="text-center align-top">
                            <div className="d-flex align-items-center justify-content-center gap-2">
                              {/* <i className="icon-add-circle icons-btn blue-text rounded-circle" style={{fontSize: '24px'}}></i> */}

                              {qoute?.length > 1 ?
                                //  <div  className="icons-btn red-text"><i className="icon-close-circle"></i>{LanguageConstants?.REMOVE}</div>
                                <i className="icon-close-circle icons-btn red-text rounded-circle" style={{ fontSize: '34px' }} onClick={() => handleRemoveDiv(res?.id)} ></i>
                                : null}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div onClick={() => handleAddDiv()} className="icons-btn blue-text mt-4" style={{ marginTop: '10px' }}  ><i className="icon-add-circle"></i>{LanguageConstants?.ADDMORE}</div>
              </div>
              <div className="form-btm-footer">
                {state?.data == null ?
                  <div className="form-btm-col">
                    <button type="submit" className="round-btn w-100">

                      {LanguageConstants?.NEXT}</button>
                  </div>
                  :
                  <>
                    <div className="form-btm-footer">
                      <button onClick={() => navigate(`/view-quotation/${state?.data}`)} className="round-btn com-btn-outline m-0 ms-auto me-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="me-2"
                          viewBox="0 0 16 16"
                        >
                          <path fillRule="evenodd" d="M15 8a.5.5 0 0 1-.5.5H2.707l4.147 4.146a.5.5 0 0 1-.708.708l-5-5a.498.498 0 0 1 0-.708l5-5a.5.5 0 1 1 .708.708L2.707 7.5H14.5A.5.5 0 0 1 15 8z" />
                        </svg>
                        {LanguageConstants?.BACK}</button>
                    
                    
                      <button type="submit" className="round-btn m-0">

                        {LanguageConstants?.CONFIRMA}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="ms-2"
                          viewBox="0 0 16 16"
                        >
                          <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-4.147-4.146a.5.5 0 0 1 .708-.708l5 5a.498.498 0 0 1 0 .708l-5 5a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" />
                        </svg>
                      </button>
                    </div>
                  </>
                }
              </div>
            </div>
          </form>
        </div>

      </main>
    </>
  )
}

export default RequestQuote